import React from 'react';
import PropTypes from 'prop-types';
import { AnimatedDiv, svgSprite } from '../../../hybrid/wrappers';
import defaultCss from './LogReg.module.scss';
import classNames from 'classnames';

const LogReg = ({ children, expandedAuthBlock, compCss, closeHandler }) => {
    const css = { ...defaultCss, ...compCss };
    return (
        <div className={css.loginWrapper}>
            <AnimatedDiv inProp={expandedAuthBlock} customClass={css.authBlockWeb}>
                <div className={css.backVideo}>
                    <video
                        playsInline
                        disablePictureInPicture
                        autoPlay
                        muted
                        className={classNames(css.officeBgVideo, 'hideControls')}
                        controls={false}
                        loop
                    >
                        <source src='/src/video/office/bg_video.mp4' type='video/mp4' />
                    </video>
                </div>
                <div onClick={() => closeHandler && closeHandler()} className={classNames('circleButton', css.closeBtn)}>
                    {svgSprite('cross')}
                </div>
                {children}
                {/*<LogRegFooter />*/}
            </AnimatedDiv>
        </div>
    );
};

LogReg.propTypes = {
    expandedAuthBlock: PropTypes.bool,
    styles: PropTypes.object
};

export default LogReg;
